import { render, staticRenderFns } from "./BorderBox4.vue?vue&type=template&id=6bd0b426"
import script from "./BorderBox4.vue?vue&type=script&lang=js"
export * from "./BorderBox4.vue?vue&type=script&lang=js"
import style0 from "./BorderBox4.vue?vue&type=style&index=0&id=6bd0b426&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports